import { render, staticRenderFns } from "./subordinateBillDetail.vue?vue&type=template&id=495ab424&scoped=true"
import script from "./subordinateBillDetail.vue?vue&type=script&lang=js"
export * from "./subordinateBillDetail.vue?vue&type=script&lang=js"
import style0 from "./subordinateBillDetail.vue?vue&type=style&index=0&id=495ab424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495ab424",
  null
  
)

export default component.exports